import { DifficultyStats } from '../PerformanceDrawer/performanceDrawerData';
import { Box } from '@mui/material';
import { pxToRem } from '@geneo2-web/shared-ui';
import { LevelRow } from '../LevelRow';
export const DifficultyProgressItem = ({
  data,
}: {
  data: DifficultyStats[];
}) => {
  const config = {
    easy: { label: 'Easy', color: '#22c55e', bg: '#dcfce7' },
    medium: { label: 'Medium', color: '#f59e0b', bg: '#fef3c7' },
    hard: { label: 'Hard', color: '#ef4444', bg: '#fecaca' },
  } as const;

  return (
    <Box display="flex" flexDirection="column" gap={pxToRem(10)}>
      {data.map((item) => {
        const conf = config[item.level];

        return (
          <LevelRow
            key={item.level}
            label={conf.label}
            correct={item.correct}
            total={item.total}
            color={conf.color}
            bgColor={conf.bg}
          />
        );
      })}
    </Box>
  );
};
